import React from 'react';

import { CSSObject, Theme } from '@emotion/react';
import {
  ContentsModuleType,
  IButtonContentsModule,
  IContentsModule,
} from 'types';
import EditButton from './EditButton';
import EditImage from './EditImage';
import { EditText } from './EditText';

interface Props {
  module: IContentsModule;
}

function EditModule({ module }: Props) {
  const renderContent = () => {
    if (module.type === 'MAIN_IMAGE' || module.type === 'SUB_IMAGE') {
      return <EditImage module={module} />;
    }

    if (module.type === 'BUTTON') {
      return <EditButton module={module as IButtonContentsModule} />;
    }

    return <EditText module={module} />;
  };

  return (
    <div
      css={[
        getStyle(module.type),
        (module.type === 'TEXT' ||
          module.type === 'SUB_TITLE' ||
          module.type === 'TITLE') && { backgroundColor: '#fff' },
      ]}
    >
      {renderContent()}
    </div>
  );
}

const getStyle =
  (type: ContentsModuleType) =>
  (theme: Theme): CSSObject => {
    switch (type) {
      case 'MAIN_IMAGE':
        return {
          padding: '0 0 24px 0',
          '> img': {
            width: '100%',
          },
        };
      case 'SUB_IMAGE':
        return {
          padding: '48px 20px',
          '> img': {
            borderRadius: '8px',
            width: '100%',
          },
        };
      case 'TITLE':
        return {
          fontSize: '24px',
          fontWeight: '700',
          padding: '0 20px 8px 20px',
          color: theme.color.grey900,
          lineHeight: '1.4',
        };
      case 'SUB_TITLE':
        return {
          fontSize: '12px',
          fontWeight: '700',
          padding: '0 20px 16px 20px',
          color: theme.color.grey800,
          lineHeight: '1.4',
        };
      case 'BUTTON':
        return {
          padding: '12px 20px',
        };
      default:
        return {
          fontSize: '14px',
          fontWeight: '400',
          padding: '0 20px',
          color: theme.color.grey800,
          lineHeight: '1.7',
        };
    }
  };
export default EditModule;
